<template>
  <span class="whitespace-nowrap">
    <span> {{ $t('price.shipping_cost_hint.plus') }}&nbsp; </span>
    <button class="underline" @click="openShippingCostHint()">
      {{ $t('price.shipping_cost_hint.shipping_cost') }}
    </button>
  </span>
</template>

<script lang="ts">
import useUiState from '~/composables/ui/useUiState'

export default defineComponent({
  name: 'ShippingCostHint',
  setup() {
    const { openShippingCostHint } = useUiState()
    return { openShippingCostHint }
  },
})
</script>
